import classNames from 'classnames'
import React from 'react'
import { WemoloTypography } from '../Wemolo'
import styles from './IconInfo.module.css'

export const IconInfo = ({ icon, value, red }: { icon: string; value: string; red?: boolean }) => {
    return (
        <div className={classNames(styles.root, { [styles.red]: red })}>
            <i className={classNames(styles.icon, 'material-icons')}>{icon}</i>

            <span className={styles.label}>
                <WemoloTypography variant="body-small" tag="span">
                    {value}
                </WemoloTypography>
            </span>
        </div>
    )
}
